const da = {
"front.faq.chat.title": "STIL ET SPØRGSMÅL",
"front.faq.chat.description": "øjeblikkelig support til restaurantgæster",
"front.faq.chat.welcome": "Her kan du stille et spørgsmål direkte.",
"front.faq.chat.placeholder": "besked",
"front.faq.chat.send": "send",
"front.faq.chat.unsupportedLanguage": "Beklager, denne chat understøtter i øjeblikket kun engelsk og tysk.",
"front.faq.chat.fallback": "Tak for din besked. I øjeblikket kan jeg kun besvare ofte stillede spørgsmål. Kontakt os direkte for mere information.",

"front.faq.chat.answer.hours": "Vi har åbent dagligt fra 10:00 til 22:00.",
"front.faq.chat.answer.reservation": "Ja, du kan reservere et bord direkte på vores hjemmeside eller telefonisk.",
"front.faq.chat.answer.groupReservation": "Ved gruppebestillinger bedes du kontakte os direkte, så vi kan finde den bedste løsning til dig.",
"front.faq.chat.answer.address": "Vores adresse er: Musterstraße 1, Berlin.",
"front.faq.chat.answer.parking": "Ja, der er parkeringsmuligheder i nærheden.",
"front.faq.chat.answer.phone": "Du kan kontakte os på +49 000 000000.",
"front.faq.chat.answer.payment": "Ja, hos os kan du betale kontant eller med kort.",
"front.faq.chat.answer.menu": "Du kan finde vores aktuelle menu på hjemmesiden. Hvis du har spørgsmål om bestemte retter, hjælper vi gerne.",
"front.faq.chat.answer.vegetarian": "Ja, vi tilbyder vegetariske retter.",
"front.faq.chat.answer.vegan": "Ja, vi har også veganske muligheder på menuen.",
"front.faq.chat.answer.allergens": "Hvis du har allergier eller intolerancer, bedes du kontakte os direkte. Vi giver gerne information om ingredienserne.",
"front.faq.chat.answer.takeaway": "Ja, mad kan også bestilles som takeaway.",
"front.faq.chat.answer.delivery": "I øjeblikket understøtter vi kun reservationer og spørgsmål via hjemmesiden.",
"front.faq.chat.answer.terrace": "Ja, i godt vejr kan du også sidde på vores terrasse.",
"front.faq.chat.answer.pets": "Kontakt os direkte, hvis du ønsker at komme med et kæledyr.",
"front.faq.chat.answer.children": "Ja, familier med børn er meget velkomne hos os.",
"front.faq.chat.answer.wifi": "Ja, Wi-Fi er tilgængeligt for vores gæster.",

"front.acquaintance.callback.placeholder": "Dit telefonnummer",
"front.acquaintance.callback.send": "Send",
"front.acquaintance.callback.sending": "Sender...",
"front.acquaintance.callback.invalidPhone": "Indtast venligst et gyldigt telefonnummer.",
"front.acquaintance.callback.success": "Anmodningen er sendt. Jeg kontakter dig snart.",
"front.acquaintance.callback.error": "Fejl ved afsendelse af anmodningen. Prøv venligst igen.",

"front.landingSeo.links.digitalMenu": "Digital menu til restauranter",
"front.landingSeo.links.qrMenu": "QR-kode-menu til restauranter",
"front.landingSeo.links.multilingualMenu": "Flersproget menu til restauranter",
"front.landingSeo.links.reservation": "Online bordreservation til restauranter",
"front.landingSeo.links.freeDigitalMenu": "Test en gratis digital menu",
"front.landingSeo.links.changeMenuOnline": "Rediger menu online",

"menu.title": "Menu",
"menu.promo": "Særlige tilbud",
"menu.empty.categoryTitle": "Udfyld kategorinavnet",
"menu.empty.itemTitle": "Udfyld produktnavnet",
"menu.empty.itemDescription": "Udfyld produktbeskrivelsen",
"cart.add": "Tilføj til kurv",
"cart.cancel": "Annuller",
"section.video": "Videopræsentation",
"section.tables": "ONLINE BORDRESERVATION",
"section.table": "VÆLG ET BORD",
"section.menu": "Restaurantmenu",
"section.faq": "FAQ",
"section.contact": "Kontakt",
"promo.buy": "Køb",

"front.tenant.resolving": "Finder restaurant via underdomæne…",
"front.tenant.notFound": "Ingen kunde fundet for dette underdomæne",
"front.tenant.resolveError": "Kunne ikke finde kunden",
"front.menu.loading": "Indlæser…",
"front.menu.loadError": "Menuen kunne ikke indlæses",
"front.menu.addtocart": "Kurv",
"front.menu.cancel": "Annuller",
"front.Number.servings": "Antal portioner",

"orbit.menu": "MENU",
"orbit.shef": "RESERVATION",
"orbit.video": "VIDEO",
"orbit.faq": "SPØRGSMÅL",
"orbit.interior": "INTERIØR",
"orbit.footer": "SOCIALE MEDIER",

"shef.title.line1": "ONLINE",
"shef.title.line2": "RESERVATION",
"shef.banner.label": "Vælg",
"shef.banner.main": "dit bord",
"shef.reserved": "RESERVERET",

"video.title": "SÅDAN LAVER VI MAD — ÆRLIGT OG LÆKKERT",
"video.add": "Tilføj video",
"add.video.but": "Tilføj",

"interior.title": "VORES INTERIØR",

"footer.kontact": "KONTAKTER",

"telegram.title": "For at konfigurere Telegram-notifikationer om bestillinger skal du:",
"telegram.title.first": "1. Hente BOT_TOKEN",
"telegram.text.first": "For at få et BOT_TOKEN skal du finde og starte @BotFather-botten i Telegram, sende kommandoen /newbot, følge instruktionerne for at oprette et unikt botnavn og brugernavn og derefter kopiere API-tokenet, som @BotFather sender som svar.",
"telegram.title.two": "2. Hente CHAT_ID",
"telegram.text.two": "For at få CHAT_ID skal du finde og starte @UserInfoBot-botten i Telegram, sende kommandoen /start og derefter kopiere det ID, du modtager i svarbeskeden.",

"cart.title": "DIN KURV",
"cart.header.aria": "Din kurv",
"cart.toggle.expand": "Udvid kurv",
"cart.toggle.collapse": "Skjul kurv",
"cart.total.label": "I alt",
"cart.total.products": "produkter",
"cart.button.primary": "bestil",
"cart.button.back": "tilbage",
"cart.button.waiter": "TJENER",

"cart.mode.takeaway": "takeaway",
"cart.mode.tableTime": "Tid og bord",
"cart.mode.tableTime.disabled": "ingen ledige borde",
"cart.mode.tableTime.tooltip": "Tid og bord",
"cart.mode.tableTime.tooltipNoFree": "ingen ledige borde",
"cart.mode.inHouse": "på stedet",

"cart.bookingFlow.title": "RESERVATION. BORDNUMMER",
"cart.deposit.itemTitle": "Bordreservation (depositum)",
"cart.deposit.lineTitle": "Depositum",
"cart.deposit.badge": "Depositum {amount}€",

"cart.table.msg.tempChosen": "Bord {table} er midlertidigt valgt ✓",
"cart.table.msg.noFree": "Desværre er der ingen ledige borde",
"cart.table.msg.chooseOrDefault": "Vælg venligst et bord eller brug standardvalget.",

"cart.table.select.reserved": "RESERVERET",
"cart.table.select.pick": "VÆLG",
"cart.table.select.any": "VILKÅRLIGT",

"cart.inHouse.title": "VÆLG DIT BORDNUMMER",
"cart.inHouse.select.placeholder": "Vælg bord",
"cart.inHouse.select.option": "Bord #{n}",

"cart.checkout.back": "Tilbage",
"cart.payment.preparing": "Forbereder betaling…",
"cart.loading": "Indlæser…",

"mockCheckout.title.paymentMethod": "BETALINGSMETODE",
"mockCheckout.method.card": "Bankkort",
"mockCheckout.method.paypal": "PayPal",
"mockCheckout.method.gpay": "Google Pay",
"mockCheckout.cardForm.title": "INDTAST KORTOPLYSNINGER",
"mockCheckout.cardForm.numberLabel": "KORTNUMMER",

"mockCheckout.error.invalidCardNumber": "Ugyldigt kortnummer",
"mockCheckout.error.enter16Digits": "Indtast 16 cifre",
"mockCheckout.error.expiryFormat": "Format MM/ÅÅ",
"mockCheckout.error.expiryMonthRange": "Måned 01–12",
"mockCheckout.error.cardExpired": "Kortet er udløbet",
"mockCheckout.error.cvc3Digits": "3 cifre",

"mockCheckout.error.sendTelegram": "Fejl ved afsendelse til Telegram",
"mockCheckout.error.generic": "Noget gik galt",

"mockCheckout.reserve.clientNotFound": "Kunde ikke fundet",
"mockCheckout.reserve.tablesNotFound": "Denne kunde har ingen bordsektion",
"mockCheckout.reserve.tableNotFound": "Bord ikke fundet",
"mockCheckout.reserve.alreadyReserved": "Dette bord er netop blevet optaget. Vælg venligst et andet.",
"mockCheckout.reserve.noFreeTables": "Der er i øjeblikket ingen ledige borde",
"mockCheckout.reserve.tableNotSelected": "Vælg venligst et bord",
"mockCheckout.reserve.genericError": "Reservationsfejl",

"mockCheckout.button.back": "tilbage",
"mockCheckout.button.pay": "BETAL",
"mockCheckout.button.sending": "…sender",
"mockCheckout.button.paid": "...",
"mockCheckout.button.payInvalidTitle": "Kontrollér venligst kortoplysningerne",

"admin.booking.lead.title": "MINIMUMSTID FØR RESERVATION",
"admin.booking.lead.note": "Dette gælder kun gæstereservationer i tilstanden “bord og tid”. Intervallet er 30 minutter.",

"dateTimeStep.select.time": "VÆLG TID",

"admin.title": "ADMINPANEL",
"admin.loading": "Indlæser…",
"admin.nav.delete": "Slet",
"admin.nav.back": "Tilbage",
"admin.nav.next": "NÆSTE",
"admin.nav.confirm": "GEM",
"admin.nav.confirm.now": "gemmer ...",
"admin.booking.settings": "Reservationsindstillinger",
"admin.booking.deposit": "DEPOSITUMBELØB",
"admin.booking.deposit.note": "Depositum opkræves, når gæsten kun reserverer et bord",

"admin.hub.editmenu": "REDIGER MENU",
"admin.hub.qr": "QR-KODE",
"admin.hub.prices": "DIN PLAN",
"admin.hub.settings": "INDSTILLINGER",

"admin.panel.editmenu": "Rediger menu",
"admin.validation.required": "Påkrævet felt",
"admin.panel.add": "Tilføj position",
"admin.panel.menu": "Rediger menuliste",
"admin.panel.telegram": "Telegram",
"admin.panel.table": "BORDSTYRING",
"admin.set.table": "Sale / borde",
"admin.set.logo": "Logo og baggrunde",
"admin.logo.successfully.applied": "Logo anvendt med succes",
"admin.logo.download.error": "Downloadfejl",
"admin.settings.number.rooms": "Antal sale",
"admin.settings.room": "Sal",

"admin.qr.title": "QR-kode til gæster",
"admin.qr.alt": "QR til restaurant",
"admin.qr.copy": "kopiér link",
"admin.qr.copied": "✓ kopieret",
"admin.qr.note": "Gæster kan scanne denne kode for straks at åbne din side.",

"admin.link.notfound": "Link ikke fundet",
"admin.table.info": "Bordstyring er tilgængelig på denne side. Status ændres ved at trykke på bordet.",
"admin.prices.temp": "Priser er midlertidigt utilgængelige.",
"admin.forgot.password": "Glemt adgangskode?",
"admin.success.description": "Klik OK og tilføj endnu et produkt",

"order.success": "Varen er tilføjet til kurven!",
"order.error": "Denne vare er allerede i kurven",

"popap.product.removal": "Fjernelse af produkt",
"popap.category.removal": "Fjernelse af kategori",
"popap.want.delete.product": "Er du sikker på, at du vil slette produktet",
"popap.want.delete.category": "Er du sikker på, at du vil slette kategorien?",

"admin.settings.guestLang": "Standardsprog for gæster",
"admin.settings.adminLang": "Standardsprog for admin",
"admin.settings.noteGuest": "Dette sprog bliver sat som standard, når gæster åbner siden.",
"admin.settings.noteAdmin": "Dette sprog bliver sat som standard i adminpanelet.",
"admin.language": "Sprog",
"admin.settings.logo": "Restaurantens logo",
"admin.settings.logo.text": "Upload dit logo (PNG/JPG/WEBP/SVG, op til 2 MB). Klik derefter på “Gem”; det nuværende logo bliver erstattet med det nye.",
"admin.settings.backtable": "Baggrundsbillede på skærmen til valg af borde",
"admin.settings.backhome": "Baggrundsbillede på startskærmen",
"admin.settings.backtable.text": "Upload et baggrundsbillede (SVG/PNG/JPG/WEBP). Klik derefter på “Gem”; den nuværende baggrund bliver erstattet med den nye.",
"admin.settings.language.visitors": "Hovedsprog for restaurantens besøgende",
"admin.settings.language.visitors.text": "Dette sprog bliver sat som primært sprog, når gæster åbner siden",
"admin.settings.language.admin": "Hovedsprog for dit adminpanel",
"admin.settings.language.admin.text": "Dette sprog bliver sat som standard, når adminpanelet åbnes",
"admin.settings.gallery": "Galleri",
"admin.settings.social": "Sociale netværk",
"admin.settings.number.tables": "Antal borde",
"admin.settings.how.many.tables": "Hvor mange borde er der i restauranten?",
"admin.settings.tables.test": "Gem antallet af borde og gå tilbage til den forrige fane for at konfigurere hvert bord separat.",
"admin.settings.upload.panoramic": "Upload et panoramabillede af din restaurants sal",
"admin.settings.table": "Bord",
"admin.settings.table.not.found": "Bord ikke fundet",
"admin.settings.contact.details": "Kontaktoplysninger",
"admin.contacts.company": "Firmanavn",
"admin.contacts.address": "Adresse",
"admin.contacts.phone": "Telefonnummer",
"admin.socials.title": "Sociale medier",
"admin.settings.rooms.hint": "Angiv venligst antallet af sale i restauranten",

"admin.settable.title": "Trin 3. Bordnummerering",
"admin.settable.text1": "Hver etiket har et nummer; placer etiketterne efter bordnumrene.",
"admin.settable.text2": "Brug kontakten til at ændre etikettens størrelse.",
"admin.settable.text3": "Gem data for det aktuelle bord og klik på det tilsvarende ikon for at skifte mellem bordene.",
"admin.setqr.title": "Dine QR-koder",
"admin.setqr.text1": "på denne side gemmes dine beskeder, menuer og QR-koder",
"admin.setqr.text2": "ved køb af BASIC-planen genereres der automatisk en QR-kode og et link til dit underdomæne (for eksempel example.best-place.club)",
"admin.setqr.text3": "du kan åbne linket, kopiere det og også gemme QR-koden som et billede på din enhed",
"admin.setpanorama.title": "Trin 2. Panoramabillede",
"admin.setpanorama.text1": "Tilføj et panoramabillede. Det anbefales at bruge lette filer, for eksempel WEBP-format.",
"admin.setpanorama.text2": "Hvis billedet er uploadet korrekt, vises det i forhåndsvisningen nedenfor.",
"admin.setnumber.title": "Trin 1. Antal borde",
"admin.setnumber.text1": "Vælg antallet af borde i din restaurant",
"admin.setnumber.text2": "Det anbefales at starte opsætningen med et eller to borde og derefter øge antallet.",

"admin.current.logo": "Nuværende logo",
"admin.add.photo": "her kan du tilføje en fil",
"admin.add.file": "filformater til upload: .xlsx, .xls, .csv",
"admin.add.file.but": "Tilføj fil",
"admin.import.format": "Kolonneformat: Kategori / Titel / Beskrivelse / Pris",
"admin.import.follow": "følg det angivne kolonneformat og forbered en fil i det tilsvarende format",
"admin.import.BeСareful": "Bemærk: tidligere data går tabt under importen",
"admin.add.photo.but": "Tilføj foto",
"admin.add.photo.set": "Tilføj foto",

"admin.wizard.step1": "Vælg kategori",
"admin.wizard.step2": "Navn og pris",
"admin.wizard.step3": "Beskrivelse og foto",
"admin.wizard.ready": "Klar",
"admin.wizard.defaultTitle": "Tilføj produkt",
"admin.wizard.step1.desc": "Trin 1. Vælg en eksisterende kategori eller opret en ny",
"admin.wizard.step2.desc": "Trin 2. Vælg et navn til produktet og angiv prisen",
"admin.wizard.step3.desc": "Trin 3. Skriv en produktbeskrivelse, tilføj et billede og klik på gem",
"admin.wizard.step1.desc.short": "Trin 1. Vælg en eksisterende eller ny kategori",
"admin.wizard.step2.desc.short": "Trin 2. Tilføj produktets navn og pris",
"admin.wizard.step3.desc.short": "Trin 3. Beskriv produktet og tilføj et foto",

"admin.wizard.tab.existing": "Eksisterende",
"admin.wizard.tab.new": "Ny",
"admin.wizard.cat.loading": "Indlæser…",
"admin.wizard.cat.empty": "Der er endnu ingen kategorier. Skift til “Ny” og opret den første.",

"admin.form.categoryKeyDe": "Kategori (KEY/DA)",
"admin.form.categoryEn": "Kategori (EN)",
"admin.form.titleMain": "Produktnavn",
"admin.form.descMain": "Produktbeskrivelse",
"admin.validation.req": "Indtast produktnavn",
"admin.form.titleDe": "Titel (DE)",
"admin.form.titleEn": "Titel (EN)",
"admin.form.nameDe": "Navn (DE)",
"admin.form.nameEn": "Navn (EN)",
"admin.form.price": "Pris",
"admin.form.descDe": "Beskrivelse (DE)",
"admin.form.descEn": "Beskrivelse (EN)",

"admin.toast.productAdded": "Produktet blev tilføjet",
"admin.tooltip.fixFormErrors": "Ret fejlene i formularen",

"admin.validation.firstCharNotDigit": "Det første tegn må ikke være et tal.",
"admin.validation.maxChars": "forkort produktnavnet",
"admin.validation.chooseCategory": "Vælg en kategori.",
"admin.validation.chooseCategoryFromList": "Vælg en kategori fra listen.",
"admin.validation.enterCategoryName": "Indtast et kategorinavn.",
"admin.validation.enterProductName": "Indtast et produktnavn.",
"admin.validation.priceFormat": "Ugyldigt prisformat (f.eks. 12.50)",
"admin.validation.enterDescription": "Indtast en beskrivelse.",
"admin.tarif.apply": "anvend",
"admin.menu.creating": "Opret menu",
"admin.choose.template": "Trin 1: Vælg en skabelon",
"admin.choose.template2": "Trin 2: Kontrollér produktlinjerne",
"admin.choose.atyle": "Vælg en menustil. Du kan ændre den senere",

"admin.error.tenantNotFound": "Ingen kunde fundet for dette underdomæne.",
"admin.error.resolveClient": "Kunne ikke finde kunden.",
"admin.error.menuLoad": "Menuen kunne ikke indlæses.",
"admin.error.saveLang": "Sproget kunne ikke gemmes.",
"admin.error.clientNotFound": "Kunden blev ikke fundet på serveren",
"admin.error.arrNotFound": "Dataarray blev ikke fundet for denne kunde",

"tpl.premium.title": "Premium",
"tpl.classic.title": "Klassisk",
"tpl.dark.title": "Mørk",
"tpl.minimal.title": "Minimalistisk",
"tpl.premium.desc": "Bestseller",
"tpl.classic.desc": "lys",
"tpl.dark.desc": "mørk",
"tpl.minimal.desc": "minimalistisk",

"tp2.position.total": "Du har nu:",
"tp2.position.punkte": "Menupunkter",
"tp2.position.template": "Skabelon",

"tp3.qr.link": "QR-kode og menulink",
"tp3.step3.title": "Trin 3: Forhåndsvisning / Publicering",
"admin.tp.progres.publication": "Publicering",
"admin.tp.progres.positionen": "Position",

"tp4.link.copy": "KOPIÉR",
"tp4.link.copy.ok": "✓ KOPIERET",

"admin.tp.publish": "Publicér",
"admin.tp.posting": "publicerer ...",

"admin.import.from.excel": "Importér menu fra Excel",

"popap.successful.payment": "Betaling gennemført",

"landing.title": "Digitale løsninger til restauranter",
"landing.title.login": "Log ind",
"landing.text": "Start din restaurantwebsite på få minutter!",
"landing.try.now": "prøv gratis",
"landing.title.to": "Hvem passer vores service til?",
"landing.title.answer": "Først og fremmest er den nyttig for ejere af restauranter, hvis mål er at tiltrække nye kunder og fastholde eksisterende",
"landing.content.title.first": "Online menu med QR-kode",
"landing.content.first": "Dine gæster kan regne med en opdateret menu og aktuelle priser ved blot at scanne QR-koden. Særlige tilbud øger gæsternes loyalitet over for dit produkt",
"landing.content.title.second": "Online bordreservationer",
"landing.content.second": "Vi tilbyder gæsterne en visuel online bordreservation med ekstra panoramabilleder. Om nødvendigt kan de skifte mellem nærliggende zoner",
"landing.content.title.third": "Stemningsfuldt indhold",
"landing.content.third": "Potentielle gæster kan se forskelligt indhold: billeder af interiøret, videoer af tilberedningen af de bedste retter og en panoramisk udsigt over salen.",
"landing.content.title.four": "Øg den gennemsnitlige regning",
"landing.content.four": "Tilbyd dine gæster arrangementer som banketter, fødselsdage eller særlige tilbud på større eller daglige bestillinger",
"landing.request": "Vi kontakter dig snart",
"callback.invalidPhone": "Indtast et gyldigt telefonnummer",
"landing.enter.number": "DIT NUMMER",
"callback.submitError": "Nummeret kunne ikke sendes. Prøv igen",
"landing.tariff.advance": "Advarsel",
"landing.tariff.advance.desc": "Inden for den valgte plan kan du gratis udfylde din applikation med indhold",
"landing.tariff.one-time-not-included": "Individuel prisberegning. I højre hjørne af skærmen finder du en kontaktknap. Efterlad dit nummer, så kontakter vi dig",
"landing.tariff.one-time-services": "Engangsydelser",
"landing.tariff.logo-creation": "Logooprettelse",
"landing.tariff.selling-images": "Salg af produktbilleder",
"landing.tariff.panorama-creation": "Oprettelse af panorama",

"demo.video.unsupported": "Din browser understøtter ikke video",
"demo.title.after": "oversigt over servicen",
"demo.title.accent": "kort",
"demo.title.before": "En",
"demo.title.total": "om servicen",
"demo.title": "Videooversigt",

"landing.free.first": "Online menu via QR-kode tilgængelig, resultat på få minutter.",
"landing.free.second": "Mulighed for at redigere menuen for den aktuelle dato",
"landing.free.third": "Adgang til menudesigneren",
"landing.basic.first": "En fuld URL-side med adgang til menuen via QR-kode",
"landing.basic.second": "Online bestilling til dine besøgende",
"landing.basic.third": "Online bordreservationer, panoramabilleder af din spisesal, klikbare borde og visning i realtid af reserverede og ledige borde",
"landing.basic.fourth": "Menu med oversættelse til alle sprog",
"landing.pro.first": "Funktionalitet, der giver dig mulighed for at administrere pristilbud, oprette bannere og marketingstrategier",
"landing.pro.second": "Mulighed for at administrere gæsteloyalitetssystemet og påvirke det endelige resultat af Google-anmeldelser",
"landing.pro.third": "",
"landing.title.free": "Gratis i 14 dage",
"landing.registerTitle": "Registrering",
"landing.tariff.selection": "Valg af plan",
"landing.tariff.subdomain": "Registrering af underdomæne",
"landing.tariff": " / pr. måned",
"landing.your.tariff": "din plan",
"landing.your.example": "for eksempel",
"landing.Subdomain.selection": "Valg af underdomæne",
"landing.password": "adgangskode",
"landing.tariff.free": "GRATIS",
"landing.tariff.free-description": "for at lære servicen at kende",
"landing.tariff.basic": "BASIC",
"landing.tariff.basic-description": "grundlæggende funktioner til at komme i gang",
"landing.tariff.pro": "PRO",
"landing.tariff.pro-description": "For avancerede brugere",
"landing.tariff.selected": "✓ valgt",
"landing.legal.text.start": "Jeg accepterer",
"footer.legal.terms": "Vilkår",
"landing.legal.text.mid": "og",
"landing.tariff.optional": "Engangsydelser",
"landing.tariff.one-time-note": "Se priser for oprettelse af salgsorienterede billeder i høj kvalitet",
"landing.tariff.pro-locked-desc": "Denne plan er endnu ikke tilgængelig",
"landing.tariff.in-development": "Under udvikling",
"landing.tariff.free-one-time-desc": "til at fylde din publikation med billeder i høj kvalitet",

"footer.legal.privacy": "Privatliv",
"footer.legal.privacy.and": "politik",
"footer.about": "Platform til restauranter: menu, bordreservationer, bestillinger og adminpanel.",

"server.common.unknown": "Ukendt fejl.",
"server.common.serverError": "Intern serverfejl.",
"server.common.networkError": "Netværksfejl. Prøv igen.",
"server.common.clientIdMissing": "Fejl: clientId mangler.",

"server.login.required": "E-mail og adgangskode er påkrævet.",
"server.login.invalidCredentials": "Ugyldig e-mail eller adgangskode.",
"server.login.signupIncomplete": "Kontoen er endnu ikke aktiv. Fuldfør registreringen.",
"server.login.success": "Login gennemført!",

"server.register.required": "E-mail og adgangskode er påkrævet.",
"server.register.emailExistsActive": "Der findes allerede en bruger med denne e-mail. Brug login.",
"server.register.resume": "Registrering fortsættes.",
"server.register.success": "Registrering gennemført!",

"server.signupComplete.success": "Aktivering gennemført!",
"server.signupComplete.error": "Aktivering mislykkedes.",

"server.subdomain.required": "clientId og underdomæne er påkrævet.",
"server.subdomain.planInvalid": "Ugyldig plan. Tilladt: free | basic | pro.",
"server.subdomain.invalid": "Ugyldigt underdomæne (a-z, 0-9, '-', 3–30, uden '-' i begyndelsen/slutningen).",
"server.subdomain.reserved": "Dette underdomæne er reserveret.",
"server.subdomain.taken": "Dette underdomæne er allerede optaget.",
"server.subdomain.userNotFound": "Bruger ikke fundet.",
"server.subdomain.success": "Underdomæne registreret. Omdirigerer…",
"server.subdomain.error": "Registrering af underdomæne mislykkedes.",

"landing.loginTitle": "Login",
"landing.btn.login": "Login",
"landing.btn.register": "Registrering",
"landing.btn.enter": "Gå ind",
"landing.loggingIn": "Logger ind…",
"landing.registering": "Registrerer…",
"landing.activating": "Aktiverer…",
"landing.subdomain.registering": "Registrerer underdomæne…",
"landing.redirecting": "Omdirigerer…",
"landing.legal.required": "Accepter venligst vilkår og privatlivspolitik.",

"landing.subdomain.err.empty": "Indtast et underdomæne.",
"landing.subdomain.err.chars": "Kun bogstaver, tal og '-', 3–30 tegn.",
"landing.subdomain.err.hyphen": "Underdomænet må ikke starte eller slutte med '-'.",
"landing.subdomain.err.reserved": "Dette underdomæne er reserveret.",

"admin.menuLanguages.title": "Menu sprog",
    "admin.menuLanguages.default": "Det sprog, som en besøgende på din virksomhed ser først (som standard)",
    "admin.menuLanguages.hint": "Vælg de sprog, der skal bruges yderligere",
    "common.success": "Gennemført",
    "admin.import.activeLangs": "Aktive menusprog",
  "admin.import.sourceLangHint": "Excel vil kun blive skrevet på det valgte sprog. Andre aktive sprog vil forblive tomme",
  "admin.import.sourceLang": "Angiv det sprog, som Excel-filen er skrevet på",
  "admin.import.mainLang": "det vigtigste",
  "booking.date.today": "I dag",
  "booking.date.tomorrow": "I morgen",
  "booking.room": "Sal",
  
  "front.faq.chat.answer.greeting": "Hej! Jeg kan hjælpe med reservationer, menu, adresse, åbningstider og andre spørgsmål.",
"front.faq.chat.answer.howAreYou": "Tak, jeg har det godt! Hvordan kan jeg hjælpe dig med restauranten?",
"front.faq.chat.answer.thanks": "Det var så lidt! Skriv endelig, hvis du har flere spørgsmål.",
"front.faq.chat.answer.goodbye": "Farvel! Vi glæder os til dit besøg.",
"front.faq.chat.answer.whoAreYou": "Jeg er restaurantens digitale assistent. Jeg hjælper gæster med ofte stillede spørgsmål.",
"front.faq.chat.answer.help": "Jeg kan hjælpe med reservationer, menu, adresse, telefonnummer, betaling, allergener, levering og andre spørgsmål.",
"front.faq.chat.answer.recommendation": "Jeg anbefaler at kigge på menuen — der finder du de aktuelle retter og kan vælge det, der passer dig bedst.",
"front.faq.chat.answer.compliment": "Mange tak! Det er vi glade for at høre.",

"checkout.button.send": "SEND",
"checkout.button.sending": "Sender ...",
"checkout.button.sent": "Sendt",
"checkout.title.order": "BESTILLING",
"checkout.phone.title": "Indtast dit telefonnummer",
"checkout.phone.label": "Telefonnummer",

"footer.workingHours": "Arbejdstid",

"admin.offline.title": "Ingen internetforbindelse",
"admin.offline.text": "Kontrollér din internetforbindelse. Du kan automatisk fortsætte arbejdet, når forbindelsen er genoprettet.",
"admin.offline.status": "Venter på forbindelse…",


};

export default da;
